export default "__VITE_ASSET__B0XhYwE4__"